<template>
  <div class="p-l-20 p-r-20 s_bf">
    <SmallSquare content='积分是提供给会员的一种奖励，可以通过购物、签到等活动获得积分，商户可以设置礼品（实物礼品、虚拟票券、购物券、微信红包、联盟卡券、直充类）提供给会员进行兑换，是一种提高客户关怀的营销手段。积分换购的实物礼品可以和商城的商品一起提交订单，提升购物转化率。可以在本页面装修设置你的积分商城首页，使得您的积分商城首页更具个性化' :padding='false'></SmallSquare>
  </div>
  <a-card :bordered="false">
    <app-warp title='积分商城' :color='pageSet.page.style.backgroundColor' v-on:handleclick="activeModule('page',-1)">
      <template #app-sider-left>
        <div class="moduleContent" style="margin-right:20px">
          <div class="moduleTitle">组件库</div>
          <div class="navs">
            <div class="navs-group">
              <div v-for="(value,index) in modules" :key="index">
                <div class="title">{{value.title}}</div>
                <div class="navs-components ">
                  <nav class="special" v-for="(item,key) in value.modules" :key="key" @click="addModule(item)">
                    <p class="item-icon">
                      <component v-if='item.icon' :is="item.icon"></component>
                    </p>
                    <p>{{item.name}}</p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #app-content>
        <div class="s_po_re">
          <img class="width100" style="position: absolute;top: 0;left: 0;" :src="pageSet.page.style.backgroundImg?info.picdomain+pageSet.page.style.backgroundImg:require('@/assets/images/integralShop/top.png')" alt="">
          <div class="p-l-8 p-r-8 p-t-20 p-b-20 s_flex_bian_c s_po_re">
            <img class="width50" src="@/assets/images/user/top.png" alt="">
            <div class="s_flex_ali">
              <img class="width-12 m-t-5 m-r-5" src="@/assets/images/jifen1.png" alt="">
              <p class="fz-25 s_cfff">15451</p>
            </div>
          </div>
          <transition-group appear tag="div">
            <template v-for="(item,key) in pageSet.items" :key="key">
              <div class="app-module" @click.stop="activeModule(item.type,key)" :class="moduleIndex==key?'app-active-module':''" @dragstart="dragstart(item,key)" @dragenter="dragenter(item,key)" @dragend="dragend(item)" draggable="true">
                <component :is="item.type" :data="item" />
                <div class="app-module-del" @click.stop="delMoudle(key)">
                  <DeleteOutlined style="font-size:18px" />
                </div>
              </div>
            </template>
          </transition-group>
        </div>
      </template>
      <template #app-sider>
        <a-button type="primary" ghost v-has:integralShopDecorationUrl="()=>getLink('point_mall_url')" style="margin-left:20px;margin-bottom:10px">
          积分商城地址
        </a-button>
        <div class="moduleContent " style="width:100%;margin-left:20px">
          <div class="moduleTitle m-b-20">页面设置</div>
          <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
            <template v-for="(value,index) in formCreateData" :key="index">
              <a-form-item :label="value.label" :help="value.help" :hidden="value.stamp=='selectgood' && modelRef['items'][moduleIndex].params.rules !== 3">
                <template v-if='moduleIndex==-1'>
                  <!-- 普通表单 -->
                  <template v-if="value.stamp=='input'">
                    <a-input v-model:value="modelRef['page'][value.key][value.name]" :type="value.type" />
                  </template>
                  <!-- 图片 -->
                  <template v-if="value.stamp=='singleImage'">
                    <material :groupType='1' :image="modelRef['page'][value.key][value.name]" :max="1" v-on:handlechoose="(data)=>{ modelRef['page'][value.key][value.name]=data}" v-on:handledel="modelRef['page'][value.key][value.name]=''" />
                  </template>
                </template>
                <template v-else>
                  <!-- 普通表单 -->
                  <template v-if="value.stamp=='input'">
                    <a-input v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" :type="value.type" :help="value.help" />
                  </template>
                  <!-- 单选框 -->
                  <template v-if="value.stamp=='radio'">
                    <a-radio-group :options="value.options" v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" />
                  </template>
                  <!-- 开关 -->
                  <template v-if="value.stamp=='switch'">
                    <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="modelRef['items'][moduleIndex][value.key][value.name]">
                      <template #checkedChildren>{{value.open}}</template>
                      <template #unCheckedChildren>{{value.close}}</template>
                    </a-switch>
                  </template>
                  <!-- 选择框 -->
                  <template v-if="value.stamp=='select'">
                    <a-select v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" :style="{width:'270px'}" placeholder="请选择">
                      <a-select-option v-for='item in value.options' :key='item.value' :value="item.value">{{item.label}}
                      </a-select-option>
                    </a-select>
                  </template>
                  <!-- 图片上传 -->
                  <template v-if="value.stamp=='image'">
                    <div v-for="(items,indexs) in modelRef['items'][moduleIndex].data" :key="indexs" class="imagesContent">
                      <a-form-item label="图片" :label-col="{span:4}" :wrapper-col="{span:17}" style='margin-bottom: 0;'>
                        <material :groupType='1' :image="items['imgUrl']" :max="1" v-on:handlechoose="(data)=>{items['imgUrl']=data}" v-on:handledel="items['imgUrl']=''" />
                      </a-form-item>
                      <a-form-item label="链接地址" :label-col="{span:4}" :wrapper-col="{span:17}" style='margin-bottom: 0;'>
                        <a-input-search v-model:value="items['linkUrl']" @search="onChooseLink(moduleIndex,indexs)" readonly>
                          <template #enterButton>
                            <a-button type="primary">
                              选择
                            </a-button>
                          </template>
                        </a-input-search>
                      </a-form-item>
                      <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
                    </div>
                    <a-button type="primary" @click="addImagesData(index)">
                      添加一个
                    </a-button>
                    <span class="s_c999">（为了页面美观，推荐上传统一的图片尺寸）</span>
                  </template>
                  <!-- 单图片上传 -->
                  <template v-if="value.stamp=='singleImage'">
                    <material :groupType='1' :image="modelRef['imgUrl']" :max="1" v-on:handlechoose="(data)=>{modelRef['imgUrl']=data}" v-on:handledel="modelRef['imgUrl']=''" />
                  </template>
                  <!-- 滑动 -->
                  <template v-if="value.stamp=='slider'">
                    <a-slider :tip-formatter="(value)=>value+'px'" v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" />
                  </template>
                  <!--导航-->
                  <template v-if="value.stamp=='nav'">
                    <template v-for="(items,indexs) in modelRef['items'][moduleIndex].data" :key="indexs">
                      <div >
                        <div class="navContent" style="background: #f7fafc;margin-bottom: 20px;">
                          <div>
                            <material :groupType='1' :image="items['imgUrl']" :max="1" v-on:handlechoose="(data)=>{items['imgUrl']=data}" v-on:handledel="items['imgUrl']=''" />
                          </div>
                          <div>
                            <div class="s_flex_ali">
                              <div style="width:150px">导航名称:</div>
                              <a-input v-model:value="items['name']" />
                            </div>
                            <div class="s_flex_ali">
                              <div style="width:150px">链接地址:</div>
                              <a-input-search v-model:value="items['linkUrl']" @search="onChooseLink(moduleIndex,indexs)" readonly>
                                <template #enterButton>
                                  <a-button type="primary">
                                    选择
                                  </a-button>
                                </template>
                              </a-input-search>
                            </div>
                          </div>
                          <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
                        </div>
                        <div>建议尺寸80*80，大小500kb以内</div>
                      </div>
                    </template>
                    <a-button type="primary" @click="addImagesData(index)" block>
                      添加一个
                    </a-button>
                  </template>
                  <template v-if="value.stamp=='selectgood' ">
                    <a-tabs type="card" v-model:activeKey="cardActiveKey">
                      <a-tab-pane :key="1" tab="已上架商品">
                        <giftList v-if='cardActiveKey == 1' :selectList="modelRef['items'][moduleIndex].data?modelRef['items'][moduleIndex].data : []" :checkout='true' v-on:select='selectGift'></giftList>
                      </a-tab-pane>
                      <a-tab-pane :key="2" :tab="'已推荐（'+(modelRef['items'][moduleIndex].data?modelRef['items'][moduleIndex].data.length :0)+'）'">
                        <div class="divScrollbar" style="height:500px;overflow-y:auto;">
                          <a-table style='width:100%' :pagination='false' bordered rowKey='id' :columns='columns' :data-source="modelRef['items'][moduleIndex].data">
                            <template v-slot:info="{ record }">
                              <a-card-meta>
                                <template #avatar>
                                  <img :src="info.picdomain+record.image" alt="" style="width:50px;height: 50px;object-fit:cover">
                                </template>
                                <template #description>
                                  <p>{{record.name}}</p>
                                  <span v-if='record.price_type == 2'>{{record.price}}元+</span>
                                  <span class="m-r-5">{{record.point}}积分</span>
                                </template>
                              </a-card-meta>
                            </template>
                            <template v-slot:action="{ record }">
                              <a-button type="primary" @click='cancelgift(record)' ghost>取消推荐</a-button>
                            </template>
                          </a-table>
                        </div>
                      </a-tab-pane>
                    </a-tabs>
                  </template>
                </template>
              </a-form-item>
            </template>
          </a-form>
        </div>
        <a-button type="primary" v-has:integralShopDecorationSet="onSubmit" class='m-l-30 m-t-10 m-r-10'>
          保存
        </a-button>
      </template>
    </app-warp>
  </a-card>
  <!-- 链接选择 -->
  <a-modal :keyboard="false" title="链接" centered v-model:visible="linkVisible" :footer="null" :width="1200" destroyOnClose>
    <links v-on:success="selecLink" />
  </a-modal>
  <!-- 积分商城链接 -->
  <a-modal :keyboard="false" title="复制链接" centered :width='600' :footer="null" v-model:visible="visibleUrl" destroyOnClose>
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <img class="width-160 height-160" :src="link.image" alt="">
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width63">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="link.url" readonly></a-input>
          <a-button type="primary" ghost @click="copy(link.url)">复制</a-button>
        </div>
        <p class="s_c999 ">可将链接复制到您的公众号菜单中</p>
      </div>
    </div>
  </a-modal>
</template>
<script>
import * as Icon from "@ant-design/icons-vue";
import banner from "./components/banner/index";
import search from "./components/search/index";
import windows from "./components/windows/index";
import nav from "./components/nav/index";
import goods from "./components/goods/index";
import guessLove from "./components/guessLove/index";
import notice from "./components/notice/index";
import giftList from "./components/giftList/index";
import { inject, onMounted, reactive, ref, toRaw, toRefs } from "vue";
import forms from "./js/form";
import modules from "./js/modules"; //基础组件数据
import store from "@/store";
import { message } from "ant-design-vue";
import { setTemplate, getTemplateDetail } from "@/api/integralShop";
import { getWebUrlDetail } from "@/api/public";
import { iscode } from "@/utils/app";
export default {
  components: {
    ...Icon,
    banner,
    search,
    nav,
    windows,
    notice,
    goods,
    guessLove,
    giftList,
  },
  setup() {
    const state = reactive({
      cardActiveKey: 1,
      form: {
        content: "",
      },
      link: {},
      visibleUrl: false,
      info: store.state.user.info,
      linkVisible: false,
      modules,
      active: "page", // 默认选中的类型、
      moduleIndex: -1,
      pageSet: {
        items: [],
        page: {
          name: "页面设置",
          style: {
            backgroundImg: "",
            backgroundColor: "#f5f5f5",
          },
          type: "page",
        },
      },
    });
    let columns = [
      {
        title: "礼品信息",
        dataIndex: "info",
        key: "info",
        slots: { customRender: "info" },
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    const $route = inject("$route");
    const $router = inject("$router");
    // 获取详情
    var modelRef = ref(state.pageSet);
    onMounted(async () => {
      getMore();
    });
    const getMore = async () => {
      let result = await getTemplateDetail()
        .then((res) => res.data)
        .catch((error) => error);
      if (result.data.content) {
        var content = JSON.parse(result.data.content);
        state.pageSet = content;
        modelRef.value = state.pageSet;
      }
      formCreate();
    };
    // 读取模块表单数据
    var formCreateData = ref({});
    const formCreate = () => {
      forms.forEach((element) => {
        if (element.type == state.active) {
          formCreateData.value = element.formItems;
        }
      });
    };
    // 读取模块默认数据
    const readMoudleData = () => {
      if (state.active == "page") {
        state.moduleIndex = -1;
        modelRef.value["page"] = JSON.parse(JSON.stringify(state.pageSet.page));
      } else {
        if (state.pageSet.items.length == 0) {
          state.moduleIndex = -1;
          modelRef.value["page"] = JSON.parse(
            JSON.stringify(state.pageSet.page)
          );
          return;
        }
        modelRef.value["items"][state.moduleIndex] = JSON.parse(
          JSON.stringify(state.pageSet.items[state.moduleIndex])
        );
      }
    };
    readMoudleData();
    // 激活模块
    const activeModule = (type, index) => {
      state.active = type;
      state.moduleIndex = index;
      readMoudleData();
      formCreate();
    };
    // 追加模块
    const addModule = (item) => {
      modelRef.value.items.push(item.defaultData);
      state.active = item.type;
      activeModule(item.type, state.pageSet.items.length - 1);
    };
    // 移除模块
    const delMoudle = (index) => {
      state.pageSet.items.splice(index, 1);
      var items = state.pageSet.items;
      if (items.length) {
        activeModule(items[items.length - 1].type, items.length - 1);
      } else {
        activeModule("page", -1);
      }
    };
    // 轮播图开始----------------------------
    // 追加图片数据
    const addImagesData = (index) => {
      modelRef.value.items[state.moduleIndex].data.push({
        imgUrl: "",
        linkType: "",
        linkUrl: "",
      });
    };
    // 删除轮播图片数据
    const delImagesData = (index) => {
      if (modelRef.value.items[state.moduleIndex].data.length == 1) {
        message.error("至少要存在一个图片配置");
      } else {
        modelRef.value.items[state.moduleIndex].data.splice(index, 1);
      }
    };
    // 轮播图结束----------------------------
    // 保存当前模版数据
    const ruleForm = ref();
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          let data = { ...state.form, content: JSON.stringify(state.pageSet) };
          var result = await setTemplate(data)
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            state.moduleIndex = -1;
            state.active = "page";
            getMore();
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    // 拖动模块顺序
    // 记录初始信息
    const start_index = ref(0);
    const end_index = ref(0);
    const dragstart = (value, index) => {
      start_index.value = index;
    };
    // 做最终操作
    const dragend = (value) => {
      let oldValue = state.pageSet.items[start_index.value];
      let newValue = state.pageSet.items[end_index.value];
      let newItems = [...state.pageSet.items];
      newItems[start_index.value] = newValue;
      newItems[end_index.value] = oldValue;
      // this.items一改变，transition-group就起了作用
      state.pageSet.items = [...newItems];
      activeModule(value.type, end_index.value);
    };
    // 记录移动过程中信息
    const dragenter = (value, index) => {
      end_index.value = index;
    };
    // 选择链接地址
    //
    var father = ref(0);
    var children = ref(0);
    const onChooseLink = (findex, index) => {
      father.value = findex;
      children.value = index;
      state.linkVisible = true;
    };
    // 地址选择完成
    const selecLink = (link) => {
      if (!link) return;
      modelRef.value["items"][father.value].data[children.value].linkUrl =
        link.url;
      modelRef.value["items"][father.value].data[children.value].linkType =
        link.type;
      state.linkVisible = false;
    };
    const _lodash = inject("_lodash");
    //选择推荐礼品
    const selectGift = (e) => {
      modelRef.value.items[state.moduleIndex].data = e.filter((v) => v.select);
    };
    // 取消推荐礼品
    const cancelgift = (e) => {
      var index = modelRef.value.items[state.moduleIndex].data.findIndex(
        (v) => e.id == v.id
      );
      modelRef.value.items[state.moduleIndex].data.splice(index, 1);
    };
    // 获取地址
    const getLink = async (code) => {
      let result = await getWebUrlDetail({ code })
        .then((res) => res.data)
        .catch((error) => error);
      state.link = result.data;
      state.visibleUrl = true;
    };
    // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };

    return {
      ...toRefs(state),
      modelRef,
      onSubmit,
      formCreateData,
      activeModule,
      addModule,
      delMoudle,
      addImagesData,
      delImagesData,
      dragenter,
      dragend,
      dragstart,
      onChooseLink,
      ruleForm,
      selecLink,
      selectGift,
      cancelgift,
      columns,
      copy,
      getLink,
    };
  },
};
</script>
<style lang="less" scoped>
.moduleContent {
  width: 285px;
  min-height: 600px;
  height: auto;
  background: #fdfdfd;
  border: 1px solid #ddd;
  padding: 15px 10px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  user-select: none;

  .moduleTitle {
    position: relative;
    padding-left: 22px;
    line-height: 30px;
    font-weight: 600;
    border-bottom: 1px solid #eef1f5;

    &::before {
      content: "";
      position: absolute;
      width: 4px;
      height: 13px;
      background: #204736;
      top: 10px;
      left: 9px;
    }
  }

  .navs {
    padding: 10px 5px;
    border-bottom: 1px dotted #ddd;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;

    .navs-group {
      display: block;
      width: 100%;

      .title {
        font-size: 0.24rem;
        color: #999;
        margin: 10px 0;
      }

      .navs-components {
        display: flex;
        flex-wrap: wrap;
      }

      .special {
        background: #f4f4f4;
        width: 74px;
        padding: 3px 0;
        margin: 5px;
        border: 1px solid #dddddd;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
      }

      p {
        color: #424242;
        font-size: 12px;
      }
    }
  }
}

.app-module {
  position: relative;

  &:hover {
    border: 2px dashed #f04635 !important;

    .app-module-del {
      display: block;
    }
  }

  .app-module-del {
    z-index: 100;
    display: none;
    position: absolute;
    right: 2px;
    bottom: 2px;
    color: #204736;
    font-size: 12px;
  }
}

.app-active-module {
  border: 2px dashed #f04635 !important;
}

.imagesContent {
  padding: 20px;
  background: #f7fafc;
  position: relative;
  border-radius: 3px;
  cursor: move;
  margin-bottom: 20px;

  .images_del {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}

.navContent {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  .images_del {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
}
.divScrollbar::-webkit-scrollbar {
  width: 4px;
}
</style>